import type { IconData } from '@stacksjs/iconify-core'

export const loadingHorizontal2: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M24 16a8 8 0 1 0 0 16a8 8 0 1 0 0-16M7 20a4 4 0 1 0 0 8a4 4 0 1 0 0-8m34 0a4 4 0 1 0 0 8a4 4 0 1 0 0-8\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 16a8 8 0 1 0 0 16a8 8 0 1 0 0-16M7 20a4 4 0 1 0 0 8a4 4 0 1 0 0-8m34 0a4 4 0 1 0 0 8a4 4 0 1 0 0-8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default loadingHorizontal2
